module.exports = __webpack_public_path__ + "img/iconContactless.ed840117.png";